import styled from 'styled-components'

import { IconsQA } from 'shared/dataAttributes'
import { colors } from 'shared/lib'

type AmexCardProps = {
  size?: 'small' | ''
}

export const AmexCard = ({ size = '' }: AmexCardProps) => (
  <Wrapper $size={size}>
    <CustomSvg
      $size={size}
      data-qa={IconsQA.AmexCardIcon}
      fill="none"
      height="6"
      viewBox="0 0 29 6"
      width="29"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Shape">
        <path
          d="M14.0916 -6.10352e-05H13.2996L11.4996 3.82794L9.69961 -6.10352e-05H7.29961V5.06394L4.99561 -6.10352e-05H2.71561L0.0996094 5.99994H1.88761L2.42761 4.66794H5.23561L5.79961 5.99994H8.79961V1.67994L10.8036 5.99994H12.2556L14.0916 2.03994V5.99994H15.6996V-6.10352e-05H14.1396H14.0916ZM2.99161 3.29994L3.80761 1.30794L4.65961 3.29994H2.99161Z"
          fill="#0072AD"
          id="Vector"
        />
        <path
          d="M28.8987 -0.00012207H26.7867L25.0827 1.79988L23.4147 -0.00012207H16.8027V5.99988H23.2827L25.0467 4.11588L26.7747 5.99988H28.8987L26.1267 2.99988L28.8987 -0.00012207ZM21.6987 5.39988V4.61988H18.3387V3.67188H21.6987V2.31588H18.3387V1.36788H21.6987V0.455878L24.0147 2.99988L21.6987 5.39988Z"
          fill="#0072AD"
          id="Vector_2"
        />
      </g>
    </CustomSvg>
  </Wrapper>
)

const CustomSvg = styled.svg<{ $size: AmexCardProps['size'] }>`
  background: ${colors.FC2_WHITE};
  height: ${({ $size }) => ($size === 'small' ? '6px' : '7px')};
  width: ${({ $size }) => ($size === 'small' ? '30px' : '35px')};
`
const Wrapper = styled.div<{ $size: AmexCardProps['size'] }>`
  align-items: center;
  background: ${colors.FC2_WHITE};
  border-radius: 2px;
  border: 1px solid ${colors.FC2_LIGHTEST_GREY};
  display: flex;
  height: ${({ $size }) => ($size === 'small' ? '24px' : '27px')};
  justify-content: center;
  width: ${({ $size }) => ($size === 'small' ? '36px' : '40px')};
`
